import { LocationSelectModalClient } from '@/components/v3/molecules/location-select/location-select-modal.client'
import { ModalPaneBackgroundClient } from '@/components/v3/molecules/modal-pane/modal-pane-background.client'
import { ModalPane } from '@/components/v3/molecules/modal-pane/modal-pane.server'
import { getDBRegionsWithLocations } from '@/utils/regions-and-locations'

export const LocationSelectModal = async () => {
  const regions = await getDBRegionsWithLocations()

  return (
    <ModalPane position="bottom">
      <ModalPaneBackgroundClient />
      <LocationSelectModalClient regions={regions} />
    </ModalPane>
  )
}
